import { Loading } from 'element-ui'
import html2canvas from 'html2canvas'
import moment from 'moment'
import jsPDF from 'jspdf'
const timeFormat = function (time, format) {
  return moment(time).format(format)
}
//递归tree
const getAllChildren = function (elementOrElements) {
  const elements = Array.isArray(elementOrElements)
    ? elementOrElements
    : [elementOrElements]
  let childrenArray = []
  for (const element of elements) {
    if (!element.children) {
      childrenArray.push(element)
    } else {
      childrenArray.push(...getAllChildren(element.children))
    }
  }
  return childrenArray
}

// 格式化日对象
const getNowDate = () => {
  var date = new Date()
  var sign2 = ':'
  var year = date.getFullYear() // 年
  var month = date.getMonth() + 1 // 月
  var day = date.getDate() // 日
  var hour = date.getHours() // 时
  var minutes = date.getMinutes() // 分
  var seconds = date.getSeconds() //秒
  // 给一位数的数据前面加 "0"
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (day >= 0 && day <= 9) {
    day = '0' + day
  }
  if (hour >= 0 && hour <= 9) {
    hour = '0' + hour
  }
  if (minutes >= 0 && minutes <= 9) {
    minutes = '0' + minutes
  }
  if (seconds >= 0 && seconds <= 9) {
    seconds = '0' + seconds
  }
  return (
    year +
    '-' +
    month +
    '-' +
    day +
    ' ' +
    hour +
    sign2 +
    minutes +
    sign2 +
    seconds
  )
}

// 文件下载

// 图片url字符串处理
// const imgUrlStr = function(url){
//     if(url){
//         let newUrl = url.substr(-10)
//     }
// }
const getBase64FromImageUrl=(url)=> {
  return new Promise((resolve) => {
    if (!url) {
      resolve(''); // 如果没有URL，返回空字符串
      return;
    }
    
    const img = new Image();
    img.setAttribute('crossOrigin', 'anonymous');
    
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      
      const dataURL = canvas.toDataURL('image/png');
      resolve(dataURL);
    };
    
    img.onerror = () => {
      // 备用方案：使用fetch
      fetch(url, { mode: 'cors', credentials: 'omit' })
        .then(response => {
          if (!response.ok) {
            // 如果fetch失败，返回一个默认的空图片
            resolve('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==');
            return;
          }
          return response.blob();
        })
        .then(blob => {
          if (blob) {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = () => {
              // 如果FileReader也失败，返回默认图片
              resolve('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==');
            };
            reader.readAsDataURL(blob);
          }
        })
        .catch(() => {
          // 如果所有方法都失败，返回默认的空图片
          resolve('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==');
        });
    };
    
    img.src = url;
  });
}
const download = function (url, name = '', suffix = '', type = 'get') {
  let loadingInstance = Loading.service({
    fullscreen: true,
    lock: true,
    text: '下载中...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)',
  })
  let token = localStorage.getItem('jwtToken')
  function createObjectURL(object) {
    return window.URL
      ? window.URL.createObjectURL(object)
      : window.webkitURL.createObjectURL(object)
  }
  const xhr = new XMLHttpRequest()
  const formData = new FormData()
  xhr.open(type, url) //url填写后台的接口地址，如果是post，在formData append参数（参考原文地址）
  xhr.setRequestHeader('Authorization', 'Bearer ' + token)
  xhr.responseType = 'blob'
  xhr.onload = function (e) {
    console.log(e, 'eeeee')
    if (this.status == 200) {
      setTimeout(() => {
        loadingInstance.close()
      })
      if (this.response.type == 'application/json') {
        return alert('下载失败，请稍后再试')
      }
      const blob = this.response
      let filename = name //这里的名字，可以按后端给的接口固定表单设置一下名字，如（费用单.xlsx,合同.doc等等）
      if (suffix && suffix.length > 1) {
        filename = filename.concat(suffix)
      }
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename)
      } else {
        var a = document.createElement('a')
        var url = createObjectURL(blob)
        a.href = url
        a.download = filename
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
      }
    } else {
      loadingInstance.close()
    }
  }
  xhr.send(formData)
}
// 导出PDF功能
/**
 * 导出页面为PDF（单页长PDF）
 * @param {String} elementSelector - 要导出的DOM元素选择器
 * @param {String} filename - 导出的文件名
 * @param {Object} options - 配置选项
 * @param {Number} options.scale - 缩放比例，默认1
 */
const exportToPDF = async function (
  elementSelector,
  filename = '导出文档',
  options = {}
) {
  try {
    const element = document.querySelector(elementSelector)
    if (!element) {
      throw new Error('未找到指定的DOM元素')
    }

    // 显示 loading
    const loadingInstance = Loading.service({
      fullscreen: true,
      lock: true,
      text: '正在导出PDF...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    })

    // 确保元素可见且有尺寸
    element.style.display = 'block'

    // 提取配置参数
    const { scale = 1, ...otherOptions } = options

    // 默认配置
    const defaultOptions = {
      scale: scale,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff',
      ...otherOptions,
    }

    try {
      // 等待一小段时间确保DOM渲染完成
      await new Promise((resolve) => setTimeout(resolve, 500))

      // 使用html2canvas截图整个元素
      const canvas = await html2canvas(element, defaultOptions)
      const imgData = canvas.toDataURL('image/jpeg', 1.0)

      // 检查canvas是否为空
      if (canvas.width === 0 || canvas.height === 0) {
        throw new Error('Canvas尺寸为0，请检查元素是否正确渲染')
      }

      // 创建PDF
      const pdf = new jsPDF('p', 'mm', 'a4')
      const pageWidth = pdf.internal.pageSize.getWidth()
      const pageHeight = pdf.internal.pageSize.getHeight()

      // 计算图片在PDF中的尺寸
      const imgWidth = pageWidth
      const imgHeight = (canvas.height * pageWidth) / canvas.width

      // 如果图片高度超过页面高度，则调整页面尺寸
      if (imgHeight > pageHeight) {
        // 创建自定义尺寸的PDF页面
        pdf.addPage([imgWidth, imgHeight])
        pdf.deletePage(1) // 删除默认的第一页
        pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight)
      } else {
        // 图片高度未超过页面高度，直接添加到PDF
        pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight)
      }

      // 保存PDF
      pdf.save(`${filename}.pdf`)

      return {
        success: true,
        message: 'PDF导出成功',
        info: {
          scale: scale,
          fileSize: '已优化',
        },
      }
    } finally {
      // 关闭 loading
      loadingInstance.close()
    }
  } catch (error) {
    console.error('PDF导出失败:', error)
    // 关闭 loading
    const loadingInstance = Loading.service({
      fullscreen: true,
      lock: true,
      text: '下载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    })
    setTimeout(() => {
      loadingInstance.close()
    }, 100)

    return {
      success: false,
      message: `PDF导出失败: ${error.message}`,
    }
  }
}
const downloadUrl = function (Url, filename) {
  let loadingInstance = Loading.service({
    fullscreen: true,
    lock: true,
    text: '下载中...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)',
  })
  const link = document.createElement('a')
  const body = document.querySelector('body')

  link.href = Url
  link.target = '_blank'
  link.download = filename

  // fix Firefox
  link.style.display = 'none'
  body.appendChild(link)

  link.click()
  body.removeChild(link)

  window.URL.revokeObjectURL(link.href)
  loadingInstance.close()
}

/**
 * 将指定DOM元素导出为PDF
 * @param {HTMLElement} element 需要导出的DOM元素
 * @param {String} pdfName 导出的PDF文件名
 */
const downloadElementAsPDF = async (element, pdfName = '导出文件.pdf') => {
  if (!element) return
  // 显示 loading
  const loadingInstance = Loading.service({
    fullscreen: true,
    lock: true,
    text: '正在导出PDF...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)',
  })
  try {
    // 确保元素可见且有尺寸
    element.style.display = 'block';
    
    // 等待一小段时间确保DOM渲染完成
    await new Promise((resolve) => setTimeout(resolve, 500));
    
    // 生成整张长图片，添加图片处理配置
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,      // 支持跨域图片
      allowTaint: true,   // 允许污染画布
      backgroundColor: '#ffffff', // 设置背景色
      logging: false,     // 关闭日志
    });
    const imgData = canvas.toDataURL('image/jpeg', 1.0);
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    // canvas像素转mm
    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * pageWidth) / canvas.width;
    let leftHeight = imgHeight;
    // 每页插入对应部分
    if (leftHeight <= pageHeight) {
      pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);
    } else {
      let renderedHeight = 0;
      while (leftHeight > 0) {
        pdf.addImage(
          imgData,
          'JPEG',
          0,
          0 - renderedHeight,
          imgWidth,
          imgHeight
        );
        leftHeight -= pageHeight;
        renderedHeight += pageHeight;
        if (leftHeight > 0) {
          pdf.addPage();
        }
      }
    }
    pdf.save(pdfName);
  } finally {
    loadingInstance.close();
  }
}

/**
 * 下载指定DOM元素为PDF文件
 * @param {HTMLElement} coverElement 封面DOM元素（占一页）
 * @param {HTMLElement} contentElement 内容DOM元素
 * @param {String} pdfName 导出的PDF文件名
 * @param {Object} options 导出选项
 * @param {String} options.orientation PDF方向，'p'为纵向，'l'为横向
 * @param {String} options.unit 单位，默认为'mm'
 * @param {String} options.format 格式，默认为'a4'
 * @param {Number} options.scale 缩放比例，默认为2
 * @param {Number} options.margin 页边距，默认为10
 */
const downloadPDF = async (coverElement, contentElement, pdfName = '导出文件.pdf', options = {}) => {
  if (!coverElement && !contentElement) {
    console.error('封面元素和内容元素不能同时为空');
    return;
  }
  
  const defaultOptions = {
    orientation: 'p',
    unit: 'mm',
    format: 'a4',
    scale: 2,
    margin: 10,
    ...options
  };
  
  // 显示 loading
  const loadingInstance = Loading.service({
    fullscreen: true,
    lock: true,
    text: '正在生成PDF...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)',
  });
  
  try {
    // 创建jsPDF实例
    const pdf = new jsPDF({
      orientation: defaultOptions.orientation,
      unit: defaultOptions.unit,
      format: defaultOptions.format,
    });
    
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    // 如果有封面元素，先添加封面
    if (coverElement) {
      // 确保封面元素可见且有尺寸
      coverElement.style.display = 'block';
      
      // 等待DOM完全渲染
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // 使用html2canvas将封面DOM元素转换为canvas
      const coverCanvas = await html2canvas(coverElement, {
        scale: defaultOptions.scale,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        logging: false,
      });
      
      const coverImgData = coverCanvas.toDataURL('image/jpeg', 1.0);
      
      // 计算封面图片在PDF中的尺寸，保持原始宽高比
      const coverImgWidth = coverCanvas.width;
      const coverImgHeight = coverCanvas.height;
      // 限制缩放比例，确保图像适应页面但不被拉伸
      const coverRatio = Math.min(pdfWidth / coverImgWidth, pdfHeight / coverImgHeight, 1); // 最大缩放比例为1
      const scaledWidth = coverImgWidth * coverRatio;
      const scaledHeight = coverImgHeight * coverRatio;
      
      // 从顶部开始放置，水平居中
      const x = (pdfWidth - scaledWidth) / 2;
      const y = 0;
      
      // 添加封面到PDF（保持宽高比，从顶部开始）
      pdf.addImage(coverImgData, 'JPEG', x, y, scaledWidth, scaledHeight);
    }
    
    // 如果有内容元素，添加内容
    if (contentElement) {
      // 确保内容元素可见且有尺寸
      contentElement.style.display = 'block';
      
      // 等待DOM完全渲染
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // 使用html2canvas将内容DOM元素转换为canvas
      const contentCanvas = await html2canvas(contentElement, {
        scale: defaultOptions.scale,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        logging: false,
      });
      
      const contentImgData = contentCanvas.toDataURL('image/jpeg', 1.0);
      
      // 计算内容在PDF中的尺寸，考虑页边距
      const contentImgWidth = pdfWidth - (defaultOptions.margin * 2);
      const contentImgHeight = (contentCanvas.height * contentImgWidth) / contentCanvas.width;
      
      // 如果内容高度超过单页PDF高度，则分页处理
      if (contentImgHeight > (pdfHeight - defaultOptions.margin * 2)) {
        let heightLeft = contentCanvas.height; // 使用原始canvas高度进行计算
        let position = 0;
        let currentPage = 0;
        
        // 如果有封面，添加新页用于内容
        if (coverElement) {
          pdf.addPage();
        }
        
        // 分页处理内容
        while (heightLeft > 0) {
          // 计算当前页需要绘制的内容高度（在canvas坐标系中）
          const pageContentHeight = (pdfHeight - defaultOptions.margin * 2) * (contentCanvas.width / contentImgWidth);
          const sliceHeight = Math.min(heightLeft, pageContentHeight);
          
          // 创建临时canvas用于裁剪内容
          const tempCanvas = document.createElement('canvas');
          const tempCtx = tempCanvas.getContext('2d');
          tempCanvas.width = contentCanvas.width;
          tempCanvas.height = sliceHeight;
          
          // 从原canvas裁剪对应部分
          tempCtx.drawImage(
            contentCanvas,
            0,
            position, // 裁剪起始位置
            contentCanvas.width,
            sliceHeight,
            0,
            0,
            contentCanvas.width,
            sliceHeight
          );
          
          // 将裁剪后的内容转换为图片
          const slicedImgData = tempCanvas.toDataURL('image/jpeg', 1.0);
          
          // 添加到PDF
          if (currentPage === 0 && coverElement) {
            // 第一页已经有封面，内容在新页面
          } else if (currentPage === 0 && !coverElement) {
            // 第一页没有封面，内容直接添加到第一页
          } else {
            pdf.addPage(); // 后续页需要新建
          }
          
          // 计算在PDF中的高度
          const drawHeight = (sliceHeight * contentImgWidth) / contentCanvas.width;
          pdf.addImage(slicedImgData, 'JPEG', defaultOptions.margin, defaultOptions.margin, contentImgWidth, drawHeight);
          
          // 更新剩余高度和位置
          heightLeft -= sliceHeight;
          position += sliceHeight;
          currentPage++;
        }
      } else {
        // 内容适合单页
        if (coverElement) {
          pdf.addPage();
        }
        pdf.addImage(contentImgData, 'JPEG', defaultOptions.margin, defaultOptions.margin, contentImgWidth, contentImgHeight);
      }
    }
    
    // 保存PDF文件
    pdf.save(pdfName);
    
    return { success: true, message: 'PDF导出成功' };
  } catch (error) {
    console.error('PDF导出失败:', error);
    return { success: false, message: error.message };
  } finally {
    loadingInstance.close();
  }
};

// 数组去重
const arrayDeduplication = function (arr) {
  var newarr = []
  for (var i = 0; i < arr.length; i++) {
    if (newarr.lastIndexOf(arr[i]) === -1) {
      newarr.push(arr[i])
    }
  }
  return newarr
}
// 数字千分位格式化
const momenyFormat = function (num, decimals = 2) {
  if (num === null || num === undefined || num === '') {
    return '0.00'
  }
  const number = Number(num)
  if (isNaN(number)) return '0.00'
  return number.toLocaleString('zh-CN', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })
}

const generateImage = async (element) => {
  const canvas = await html2canvas(element)
  const img = canvas.toDataURL('image/png')
  return img
}

// 数字千分位格式化
const formatThousand = function (num, decimals = 2) {
  if (num === null || num === undefined || num === '') {
    return '0.00'
  }
  const number = Number(num)
  if (isNaN(number)) return '0.00'
  return number.toLocaleString('zh-CN', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })
}

/**
 * 防抖函数 - 在事件被触发n秒后再执行回调，如果在这n秒内又被触发，则重新计时
 * @param {Function} func - 需要防抖的函数
 * @param {Number} wait - 延迟时间，单位毫秒
 * @param {Boolean} immediate - 是否立即执行，默认为false
 * @returns {Function} 返回防抖后的函数
 *
 * @description
 * 防抖函数的作用是限制函数的执行频率，常用于以下场景：
 * 1. 搜索输入框：用户停止输入后才执行搜索请求
 * 2. 按钮点击：防止用户快速重复点击
 * 3. 窗口resize：窗口大小调整完成后才执行回调
 * 4. 表单验证：用户停止输入后才进行验证
 *
 * @example
 * // 基础用法
 * const debouncedSearch = debounce((value) => {
 *   console.log('搜索:', value)
 * }, 500)
 *
 * // 立即执行版本
 * const debouncedClick = debounce(() => {
 *   console.log('按钮被点击')
 * }, 300, true)
 *
 * // 在Vue组件中使用
 * methods: {
 *   handleSearch: debounce(function(e) {
 *     this.searchData(e.target.value)
 *   }, 500)
 * }
 */
const debounce = function (func, wait, immediate = false) {
  let timeout // 存储定时器ID

  return function executedFunction(...args) {
    // 延迟执行的函数
    const later = () => {
      timeout = null // 清除定时器引用
      if (!immediate) func.apply(this, args) // 非立即执行模式下调用原函数
    }

    // 判断是否应该立即执行
    const callNow = immediate && !timeout

    // 清除之前的定时器
    clearTimeout(timeout)

    // 设置新的定时器
    timeout = setTimeout(later, wait)

    // 立即执行模式且没有定时器时，立即执行函数
    if (callNow) func.apply(this, args)
  }
}

/**
 * 节流函数 - 规定在一个单位时间内，只能触发一次函数
 * @param {Function} func - 需要节流的函数
 * @param {Number} limit - 时间间隔，单位毫秒
 * @returns {Function} 返回节流后的函数
 *
 * @description
 * 节流函数的作用是确保函数在指定时间间隔内最多执行一次，常用于以下场景：
 * 1. 滚动事件：限制滚动处理函数的执行频率
 * 2. 鼠标移动：限制鼠标移动事件的处理频率
 * 3. 窗口resize：限制窗口大小调整的处理频率
 * 4. 拖拽操作：限制拖拽过程中的处理频率
 * 5. 动画效果：控制动画帧率
 *
 * @example
 * // 基础用法
 * const throttledScroll = throttle(() => {
 *   console.log('滚动事件')
 * }, 100)
 *
 * // 在Vue组件中使用
 * methods: {
 *   handleScroll: throttle(function() {
 *     this.updateScrollPosition()
 *   }, 16) // 约60fps
 * }
 *
 * // 在React中使用
 * const handleMouseMove = useCallback(
 *   throttle((e) => {
 *     setMousePosition({ x: e.clientX, y: e.clientY })
 *   }, 16),
 *   []
 * )
 */
const throttle = function (func, limit) {
  let inThrottle // 节流状态标志

  return function executedFunction(...args) {
    // 如果不在节流状态，执行函数
    if (!inThrottle) {
      func.apply(this, args) // 执行原函数
      inThrottle = true // 设置节流状态

      // 设置定时器，在指定时间后解除节流状态
      setTimeout(() => (inThrottle = false), limit)
    }
    // 如果在节流状态，忽略本次调用
  }
}
// 格式化成年月日
// 使用方式
// var year = getDateTime('year');
// console.log(year);  // 2021
// var month = getDateTime('month');
// console.log(month); // 2021-12
// var date = getDateTime('');
// console.log(date);  // 2021-12-03 09:00:00
// 日期格式化年月日函数
const formatDate = function (type, format) {
  var date = new Date()
  var hengGang = '-'
  var maoHao = ':'
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var curDate = date.getDate()
  var curHours = date.getHours()
  var curMinutes = date.getMinutes()
  var curSeconds = date.getSeconds()
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (curDate >= 0 && curDate <= 9) {
    curDate = '0' + curDate
  }
  if (curHours >= 0 && curHours <= 9) {
    curHours = '0' + curHours
  }
  if (curMinutes >= 0 && curMinutes <= 9) {
    curMinutes = '0' + curMinutes
  }
  if (curSeconds >= 0 && curSeconds <= 9) {
    curSeconds = '0' + curSeconds
  }
  var currentdate = ''
  if (type == 'format') {
    // 传递需要的日期 格式化成年月日 只要年月日  format是传递的日期参数
    currentdate = format.slice(0, 10)
    return currentdate
  } else if (type == 'year') {
    // 获取年份
    currentdate = year
    return currentdate
  } else if (type == 'month') {
    // 获取年份月份
    currentdate = year + hengGang + month
    return currentdate
  } else if (type == 'day') {
    // 获取年月日
    currentdate = year + hengGang + month + hengGang + curDate
    return currentdate
  } else if (type == 'minutes') {
    // 获取年月日 时分
    currentdate =
      year +
      hengGang +
      month +
      hengGang +
      curDate +
      ' ' +
      curHours +
      maoHao +
      curMinutes
  } else {
    // 获取年月日 + 当前时间
    currentdate =
      year +
      hengGang +
      month +
      hengGang +
      curDate +
      ' ' +
      curHours +
      maoHao +
      curMinutes +
      maoHao +
      curSeconds
    return currentdate
  }
}
const setSize = (size) => {
  let data = ''
  const _size = Number.parseFloat(size)
  if (_size < 1 * 1024) {
    //如果小于0.1KB转化成B
    data = _size.toFixed(2) + 'B'
  } else if (_size < 1 * 1024 * 1024) {
    //如果小于0.1MB转化成KB
    data = (_size / 1024).toFixed(2) + 'KB'
  } else if (_size < 1 * 1024 * 1024 * 1024) {
    //如果小于0.1GB转化成MB
    data = (_size / (1024 * 1024)).toFixed(2) + 'MB'
  } else {
    //其他转化成GB
    data = (_size / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
  }
  const size_str = data + ''
  const len = size_str.indexOf('.')
  const dec = size_str.substr(len + 1, 2)
  if (dec == '00') {
    //当小数点后为00时 去掉小数部分
    return size_str.substring(0, len) + size_str.substr(len + 3, 2)
  }
  return size_str
}
export default {
  getNowDate,
  download,
  downloadUrl,
  arrayDeduplication,
  momenyFormat,
  getAllChildren,
  generateImage,
  formatThousand,
  timeFormat,
  downloadElementAsPDF,
  downloadPDF,
  exportToPDF,
  formatDate,
  debounce,
  throttle,
  setSize,
  getBase64FromImageUrl
}
